import DOMPurify from "dompurify";

const SafeHtml = ({ html }: {html: string}) => {
    const sanitized = DOMPurify.sanitize(html); // Sanitize first if needed
    return <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
}

export default SafeHtml